module.exports = __webpack_public_path__ + "static/media/LogoColour.aa69213b.svg";